export enum ACTIONS {
    canCreate = 'canCreate',
    canRead = 'canRead',
    canUpdate = 'canUpdate',
    canDelete = 'canDelete',
    canSeeCosts = 'canSeeCosts'
};